import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const files = import.meta.glob('/app/assets/**/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true
});

function SVG({ src, className, elementType, ...passedProps }) {
  const svg = files[`/app/assets/${src}`];

  const ElementType = elementType || 'div';

  return (
    <ElementType
      {...passedProps}
      className={classNames('embedded-svg', className)}
      dangerouslySetInnerHTML={ { __html: svg } }
    />
  );
}

SVG.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  elementType: PropTypes.string
};

export default SVG;
